var defaultStyles = {
  "root": "Base-Breadcrumbs",
  "item": "Base-Breadcrumbs--Item",
  "icon": "Base-Breadcrumbs--Icon",
  "ellipses": "Base-Breadcrumbs--Ellipses",
  "separator": "Base-Breadcrumbs--Separator"
};

export { defaultStyles as default };
